import React from "react"
import PropTypes from "prop-types"
import { FormControl, MenuItem, Select } from "@mui/material"

const formControlSx = {
  maxWidth: 320,
  width: "100%",
  mb: 0.75,
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    fontSize: 13,
  },
}

/**
 * Select outlined compacto para el modal de descarga (Excel / PDF / BC3).
 */
const BudgetExportSelect = ({
  value,
  onChange,
  options,
  inputRef,
  disabled = false,
  testId,
}) => (
  <FormControl
    size="small"
    fullWidth
    sx={formControlSx}
    disabled={disabled}
    data-testid={testId}
  >
    <Select
      variant="outlined"
      value={value}
      onChange={onChange}
      inputRef={inputRef}
      inputProps={testId ? { "data-testid": `${testId}-input` } : undefined}
      MenuProps={{
        PaperProps: {
          elevation: 0,
          ...(testId ? { "data-testid": `${testId}-menu` } : {}),
          sx: {
            borderRadius: "4px",
            boxShadow: "none",
            border: "1px solid #eee",
            mt: 0.5,
          },
        },
      }}
    >
      {options.map(opt => (
        <MenuItem
          key={String(opt.value)}
          value={opt.value}
          data-testid={
            testId ? `${testId}-option-${String(opt.value)}` : undefined
          }
        >
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

BudgetExportSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  disabled: PropTypes.bool,
  testId: PropTypes.string,
}

export default BudgetExportSelect
